import React from 'react';
import {makeStyles} from "@material-ui/core/styles";


import './StepHistoryStyle.css'
import clsx from "clsx";

function StepItem(props){

    const {title, hours, isDone} = props

    return (
        <div className="timeline-item">
            <div className={clsx(['timeline-label font-weight-bolder text-gray-800 fs-6',{'text-success': isDone}])}>{hours || '-'}</div>
            <div className="timeline-badge">
                <i className={clsx(["fa fa-genderless",{'text-primary': isDone, fontSize: 24}])}></i>
            </div>
            <div className={clsx(['fw-mormal timeline-content font-weight-bolder text-success ps-3',{'text-muted font-weight-light': !isDone}])}>
                {title}
            </div>
        </div>
    );
}


export default function StepHistory(props) {

    // const classes = useStyles();

    const {histories} = props;

    return (
        <div className={'timeline-label'}>
            {
                histories.map(
                    (history,index)=>{
                        return (
                            <StepItem title={history.label} isDone={history.isDone} hours={history.hours}  />
                        );
                    }
                )
            }
        </div>
    );
}